import { Box, Container, IconButton, Typography } from "@mui/material";
import AppButton from "./AppButton";
import AppDialog from "./AppDialog";
import RocketfuelFullLogo from "../assets/logo/rocketfuel-fulllogo.svg";
import Cross from "../assets/logo/cross.svg";
import config from "../utils/config";
import { useTranslation } from "react-i18next";
import { logEvent } from "../store/api";
import { EVENTS } from "../utils/events";

export default function BlockedFullscreenDialog({ showBlocked, setShowBlocked }) {
  const { t } = useTranslation();

  const handleClick = (element) => {
    logEvent({
      current: EVENTS.LOGIN_EVENT,
      activity: `Clicked on ${element}`
    })
  }
  const closeBlockScreen = () => {
    setShowBlocked(false)
  }
  return (
    <AppDialog show={showBlocked} showClose={false}>
      <Container maxWidth="xs" sx={{ padding: 2, display: 'flex', flexFlow: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <Box sx={{ width: '100%', textAlign: 'right' }}>
          <IconButton onClick={closeBlockScreen}  aria-label="tracker"
              aria-describedby="close_block_screen">
            <Cross
              aria-label="tracker"
              aria-describedby="close_block_screen"
              style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
              }}
            />
          </IconButton>
        </Box>
        <Box
          display={"flex"}
          flexDirection="row"
          alignItems={"center"}
          justifyContent="center"
          padding={1}
        >
          <RocketfuelFullLogo style={{ width: 260, height: 42 }} />
        </Box>
        <Box
          color="#F8FAFF"
          display="flex"
          flexDirection={"column"}
          marginTop={10}
          justifyContent="center"
          alignItems={"center"}
        >
          <Cross style={{ width: 84, height: 84 }} />
          <Typography
            textAlign={"center"}
            marginTop={5}
            fontSize={24}
            fontWeight={700}
          >
            {t("loginFailedTitle")}
          </Typography>
          <Typography
            textAlign={"center"}
            marginTop={5}
            color="#D4D4D8"
            fontSize={16}
            fontWeight={400}
          >
            {t("loginFailedSubtitle")}
          </Typography>
          <AppButton
            href={config.ZENDESK_SUPPORT}
            onClick={() => handleClick('Contact Support Link')}
            target="_blank"
            title={t("contact")}
            sx={{ marginTop: 10 }}
          ></AppButton>
        </Box>
      </Container>
    </AppDialog>
  );
}
